import React, { Component } from 'react'
import { connect } from 'react-redux'
import './LikeButton.css'

class LikeButton extends Component {
  render () {
    const clickable = this.props.activeTab !== 'ANSWERED'

    return (
      <div className={`like-button-wrap ${clickable && 'cursor-pointer'}`} onClick={clickable ? this.props.onClick : () => {}}>
        <div className='like-button-heart'>
          {!this.props.active && (
            <img src='/imgs/heart.png' className='image-heart' alt='' />
          )}
          {this.props.active && (
            <img src='/imgs/heart_active.png' className='image-heart' alt='' />
          )}
        </div>
        <div className='like-button-text'>{this.props.text || '28 likes'}</div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    activeTab: state.comments.activeTab
  }
}

export default connect(mapStateToProps)(LikeButton)



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/buttons/LikeButton.js